interface StoreDomain {
  domain: string;
  isPrimary: boolean;
}

interface StoreWithDomains {
  domains?: StoreDomain[];
}

/**
 * Returns the best public URL for a store, preferring a custom domain
 * (non-hystore.com.br) over the platform subdomain.
 *
 * If the store has hywer.net registered, links and payment redirects
 * will use https://hywer.net instead of https://hywer.hystore.com.br.
 */
export function getStoreFrontUrl(store: StoreWithDomains): string {
  const domains = store.domains ?? [];

  // Prefer custom domain (doesn't end with hystore.com.br)
  const custom = domains.find((d) => !d.domain.endsWith('.hystore.com.br'));
  if (custom) return `https://${custom.domain}`;

  // Fall back to primary platform subdomain
  const primary = domains.find((d) => d.isPrimary) ?? domains[0];
  if (primary) return `https://${primary.domain}`;

  // Last resort: current origin
  return window.location.origin;
}

/**
 * Returns the domain string (without protocol) for API calls that expect
 * a domain, also preferring the custom domain.
 */
export function getStoreDomain(store: StoreWithDomains): string {
  const domains = store.domains ?? [];
  const custom = domains.find((d) => !d.domain.endsWith('.hystore.com.br'));
  if (custom) return custom.domain;
  const primary = domains.find((d) => d.isPrimary) ?? domains[0];
  return primary?.domain ?? window.location.hostname;
}
